import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../../component/Inc/Tab';
import PopStudentDetail from '../../mypage/_PopStudentDetail';
function AccountingMonthDetail() {
  const [modalStudentDetail, setModalStudentDetail] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '진행중 수업', value: 0},
    {title: '종료된 수업', value: 1},
    {title: '수업별 환불 내역', value: 2}
  ];
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  return (
    <main className="com_container com_inout_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_1">홍학생103(경기고1ㆍ남)</h2>
          <div className="com_btn_wrap">
            <button onClick={() => {}} className="com_btn orange s btn_plus">
              수업등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            {tabIdx === 0 ? (
              <>
                <div className="class_wrap">
                  <hr className="com_divider" />
                  <div className="com_board_list__top">
                    <div className="info">
                      <span className="com_icon blue">수업 진행중</span>
                      <div className="item">
                        <span className="cont">수시</span>
                        <span className="bar" />
                        <span className="cont">생기부디자인</span>
                        <span className="bar" />
                        <span className="cont">1:1대면</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">메인교사 : </span>
                        <span className="cont">김교사103</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">서브교사 : </span>
                        <span className="cont">최교사103</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">담임 : </span>
                        <span className="cont">최담임103</span>
                      </div>
                    </div>
                    <div className="com_btn_wrap">
                      <button className="com_btn xs gray">수업 변경</button>
                      <button className="com_btn xs gray">결제/결제방법 변경</button>
                      <button className="com_btn xs orange">미 입금액 결제하기</button>
                    </div>
                  </div>
                  <table className="com_board_list">
                    <colgroup>
                      <col width="4%" />
                      <col width="10%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>수업시간</th>
                        <th>최근 수업일</th>
                        <th>회차 / T</th>
                        <th>진행 회차</th>
                        <th>기수</th>
                        <th>메인교사 시수</th>
                        <th>서브교사 시수</th>
                        <th>1회 수업료</th>
                        <th>총 수업료</th>
                        <th>할인</th>
                        <th>실 수업료</th>
                        <th>총 입금 회차</th>
                        <th>총 입금액</th>
                        <th>미 입금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>60분</td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>12/1T</td>
                        <td>12회</td>
                        <td>1기</td>
                        <td>46,000</td>
                        <td>30,000</td>
                        <td>
                          460,000 <br />
                          40,000
                        </td>
                        <td>407,000</td>
                        <td>형제할인 2%</td>
                        <td>456,000</td>
                        <td className="td_point">8.56</td>
                        <td className="td_point">456,000</td>
                        <td className="td_red">10,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="com_board_list">
                    <colgroup>
                      <col width="5%" />
                      <col width="12%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="8%" span={4} />
                      <col width="17%" />
                      <col width="8%" span={2} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                            <label htmlFor="rdo01"></label>
                          </div>
                        </th>
                        <th>
                          <button
                            onClick={() => {
                              setIsOrderActive1(!isOrderActive1);
                            }}
                            className={`arrow ${isOrderActive1 ? `active` : ``}`}
                          />
                          입금일
                        </th>
                        <th>기수</th>
                        <th>회차</th>
                        <th>입금액</th>
                        <th>3개월 선입금</th>
                        <th>입금처리 액</th>
                        <th>결제방법</th>
                        <th>입금내용</th>
                        <th>입금자</th>
                        <th>미 입금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                            <label htmlFor="rdo02"></label>
                          </div>
                        </td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>2</td>
                        <td>1.52</td>
                        <td className="td_point">850,000</td>
                        <td>-5% 할인</td>
                        <td className="td_point">1,000,000</td>
                        <td>카드</td>
                        <td>하나카드 132-321-312</td>
                        <td>홍길동</td>
                        <td className="td_red">10,000</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                            <label htmlFor="rdo03"></label>
                          </div>
                        </td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>2</td>
                        <td>1.52</td>
                        <td className="td_point">110,000</td>
                        <td>-</td>
                        <td className="td_point">-</td>
                        <td>현금</td>
                        <td>무통장입금</td>
                        <td>홍길동</td>
                        <td className="td_red">10,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn orange xs btn_plus">수업 히스토리</button>
                    <button className="com_btn black xs btn_down_orange">다운로드</button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="class_wrap">
                  <div className="com_board_list__top">
                    <div className="info">
                      <span className="com_icon red">인계</span>
                      <div className="item">
                        <span className="cont">영어</span>
                        <span className="bar" />
                        <span className="cont">중등일반</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">교사 : </span>
                        <span className="cont">김교사103 {`→`} 최교사103</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">담임 : </span>
                        <span className="cont">최담임103</span>
                      </div>
                      <span className="bar" />
                      <div className="item">
                        <span className="tit">홍보 : </span>
                        <span className="cont">최홍보103</span>
                      </div>
                    </div>
                    <div className="com_btn_wrap">
                      <button className="com_btn xs gray">수업 변경</button>
                      <button className="com_btn xs gray">결제/결제방법 변경</button>
                      <button className="com_btn xs orange">미 입금액 결제하기</button>
                    </div>
                  </div>
                  <table className="com_board_list">
                    <colgroup>
                      <col width="4%" />
                      <col width="10%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="6%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>수업시간</th>
                        <th>최근 수업일</th>
                        <th>회차 / T</th>
                        <th>진행 회차</th>
                        <th>기수</th>
                        <th>시수</th>
                        <th>1회 수업료</th>
                        <th>총 수업료</th>
                        <th>할인</th>
                        <th>실 수업료</th>
                        <th>총 입금 회차</th>
                        <th>총 입금액</th>
                        <th>미 입금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>60분</td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>12/1T</td>
                        <td>12회</td>
                        <td>1기</td>
                        <td>46,000</td>
                        <td>30,000</td>
                        <td>407,000</td>
                        <td>형제할인 2%</td>
                        <td>456,000</td>
                        <td className="td_point">8.56</td>
                        <td className="td_point">456,000</td>
                        <td className="td_red">10,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="com_board_list">
                    <colgroup>
                      <col width="5%" />
                      <col width="12%" />
                      <col width="6%" />
                      <col width="6%" />
                      <col width="8%" span={4} />
                      <col width="17%" />
                      <col width="8%" span={2} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                            <label htmlFor="rdo01"></label>
                          </div>
                        </th>
                        <th>
                          <button
                            onClick={() => {
                              setIsOrderActive1(!isOrderActive1);
                            }}
                            className={`arrow ${isOrderActive1 ? `active` : ``}`}
                          />
                          입금일
                        </th>
                        <th>기수</th>
                        <th>회차</th>
                        <th>입금액</th>
                        <th>3개월 선입금</th>
                        <th>입금처리 액</th>
                        <th>결제방법</th>
                        <th>입금내용</th>
                        <th>입금자</th>
                        <th>미 입금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                            <label htmlFor="rdo02"></label>
                          </div>
                        </td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>2</td>
                        <td>1.52</td>
                        <td className="td_point">850,000</td>
                        <td>-5% 할인</td>
                        <td className="td_point">1,000,000</td>
                        <td>카드</td>
                        <td>하나카드 132-321-312</td>
                        <td>홍길동</td>
                        <td className="td_red">10,000</td>
                      </tr>
                      <tr>
                        <td>
                          <div className="check">
                            <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                            <label htmlFor="rdo03"></label>
                          </div>
                        </td>
                        <td className="td_date">2022, 08, 25 14:20</td>
                        <td>2</td>
                        <td>1.52</td>
                        <td className="td_point">110,000</td>
                        <td>-</td>
                        <td className="td_point">-</td>
                        <td>현금</td>
                        <td>무통장입금</td>
                        <td>홍길동</td>
                        <td className="td_red">10,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn orange xs btn_plus">수업 히스토리</button>
                    <button className="com_btn black xs btn_down_orange">다운로드</button>
                  </div>
                </div>
              </>
            ) : (
              tabIdx === 2 && (
                <>
                  <table className="com_board_list">
                    <colgroup>
                      <col width="8%" />
                      <col width="5%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="14%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="8%" />
                      <col width="8%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>환불 요청일</th>
                        <th>과목</th>
                        <th>상품가격</th>
                        <th>수업 진행</th>
                        <th>결제액</th>
                        <th>결제 방법</th>
                        <th>환불사유</th>
                        <th>환불액</th>
                        <th>
                          수수료 <br />
                          <span className="sub">(담임이 지불)</span>
                        </th>
                        <th>환불 처리일</th>
                        <th>교사</th>
                        <th>담임</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="td_date">2022, 08, 25</td>
                        <td>과탐</td>
                        <td>466,000</td>
                        <td>12/16</td>
                        <td>46,600</td>
                        <td>
                          가상계좌 <br />
                          국민은행(32174-3214)
                        </td>
                        <td>결제 방식 변경</td>
                        <td className="td_red">-150,000</td>
                        <td className="td_red">-10,000</td>
                        <td className="td_red">환불요청</td>
                        <td>
                          <button className="btn_link">가담임82</button>
                        </td>
                        <td>
                          <button className="btn_link">가담임82</button>
                        </td>
                      </tr>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                        return (
                          <tr key={idx}>
                            <td className="td_date">2022, 08, 25</td>
                            <td>과탐</td>
                            <td>466,000</td>
                            <td>12/16</td>
                            <td>46,600</td>
                            <td>
                              가상계좌 <br />
                              국민은행(32174-3214)
                            </td>
                            <td>결제 방식 변경</td>
                            <td className="td_red">-150,000</td>
                            <td className="td_red">-</td>
                            <td className="td_point">
                              <button className="btn_link blue">2022.09.20</button>
                            </td>
                            <td>
                              <button className="btn_link">가담임82</button>
                            </td>
                            <td>
                              <button className="btn_link">가담임82</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn black xs btn_down_orange">다운로드</button>
                  </div>
                </>
              )
            )}
          </section>
        </section>
      </div>
      <PopStudentDetail open={modalStudentDetail} close={() => setModalStudentDetail(false)} />
    </main>
  );
}

export default AccountingMonthDetail;
